import { IAccount } from "../../interfaces/ux/account.interface";
import { Utilities, Dictionary, LocalStorageHelper, Enums } from "../../utils/utilities";
import { useSelector } from "react-redux";
import { BasePresenter } from "../base/base.presenter";
import { UserDTO, ILang, UserInfoDTO } from "../../models";
import { IConfig, SPEnvironment } from "@/config/config";
const config = require('@/config/config.json') as IConfig;

export class AccountPresenter extends BasePresenter<IAccount> {
    private _langs: ILang[];
    private _lang: ILang;
    private _user: UserDTO;
    private _labels: Dictionary<string, string>;
    public constructor(params: IAccount) {
        super(params);
        this._langs = useSelector(this.context.sessionStore.selectLangs) as ILang[];
        this._lang = useSelector(this.context.sessionStore.selectLang) as ILang;
        this._user = useSelector(this.context.sessionStore.selectUser) as UserDTO;
        this._labels = useSelector(this.context.sessionStore.selectLabels) as Dictionary<string, string>;
    }
    public get User(): UserInfoDTO {
        if (!Utilities.isNullObject(this._user)) {
            if (!Utilities.isNullObject(this._user.currentUser)) {
                return this._user.currentUser;
            }

        }
        return new UserInfoDTO();
    }
    public get _currentUser(): UserDTO {
        return this.currentUser
    }
    public get langs(): ILang[] {
        if (!Utilities.isNullObject(this._langs)) {
            return this._langs;
        }
        return [];
    }
    public setCurrentLanguage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currenLangId = parseInt(e.target.value);
        const currentLang = this._langs.find(lang => lang.id === currenLangId);
        this.dispatcher(this.context.sessionStore.setLang(currentLang));
    }
    public get selectedLang(): number {
        if (!Utilities.isNullObject(this._lang)) {
            return this._lang.id;
        }
    }

    public logout = () => {
        this.dispatcher(this.context.sessionStore.actions.getCurrentUser(null));
        LocalStorageHelper.remove(Enums.LocalStorageKeys.currentUser);
        LocalStorageHelper.remove(Enums.LocalStorageKeys.currentLang);

        if (config.environment === SPEnvironment.local) {
            this.context.history.push('/proyecta/logout');
        } else {
            const url = `${config.proxy}/.auth/logout?post_logout_redirect_uri=/proyecta/logout`;
            window.location.href = url;
        }


    }

    //labels
    public get logoutLabel(): string {
        return this._labels.get('CerrarSesion');
    }
    public get rolLabel(): string {
        return this._labels.get('Rol');
    }
    public get countryLabel(): string {
        return this._labels.get('Pais');
    }
    public get languageLabel(): string {
        return this._labels.get('Idioma');
    }
}
